module.exports = __webpack_public_path__ + "static/img/914b595c9fde7da8b2c1991790727d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon6.png
// module id = p2UR
// module chunks = 1